import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { TFunction } from "i18next";

export const getNextStepTranslation = (
  currentAction: ModuleCommandEnum,
  translator: TFunction
) => {
  let resultTranslation: string | null = null;
  switch (currentAction) {
    case ModuleCommandEnum.UP:
      resultTranslation = translator("areaActions.open");
      break;
    case ModuleCommandEnum.DOWN:
      resultTranslation = translator("areaActions.open");
      break;
    case ModuleCommandEnum.OPEN:
      resultTranslation = translator("areaActions.close");
      break;
    case ModuleCommandEnum.CLOSE:
      resultTranslation = translator("areaActions.down");
      break;
  }

  if (!resultTranslation) {
    throw new Error("No translation found");
  }

  return resultTranslation;
};
